// Main.js
import React, { useMemo, useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import DolumEkle from "./pages/DolumEkle";
import TankIkmal from "./pages/TankIkmal";
import Raporlar from "./pages/Raporlar";
import DolumDuzeltSil from "./pages/DolumDuzeltSil";
import TankDuzeltme from "./pages/TankDuzeltme";
import Hareketler from "./pages/Hareketler";
import MailScheduler from "./pages/MailScheduler";
import YakitExcelYukle from "./pages/YakitExcelYukle";
import MazotListesi from "./pages/MazotListesi"; // ✅ EKLENDİ
import { useAuth } from "../../context/AuthContext";

import { collection, query, where, onSnapshot, limit } from "firebase/firestore";
import { db } from "./firebaseConfig";

// Firestore’dan doğrudan mazot-takip map’ini getirir (email ile)
function useMazotPermissions(user, userPermissions, userDoc) {
  const [ready, setReady] = React.useState(false);
  const [perms, setPerms] = React.useState(null);

  React.useEffect(() => {
    // 1️⃣ Context’ten varsa hemen kullan
    const extractMazotMap = (obj = {}) => {
      if (!obj || typeof obj !== "object") return null;
      return (
        obj["mazot-takip"] ||
        obj.mazot_takip ||
        obj.mazottakip ||
        obj.mazotTakip ||
        null
      );
    };

    const fromCtx =
      extractMazotMap(userPermissions || {}) ||
      extractMazotMap(userDoc || {});

    if (fromCtx) {
      setPerms(fromCtx);
      setReady(true);
      return;
    }

    // 2️⃣ Context’te yoksa Firestore’dan çek
    if (!user?.email) {
      setReady(true);
      return;
    }

    const qRef = query(
      collection(db, "users"),
      where("email", "==", user.email),
      limit(1)
    );

    const unsub = onSnapshot(
      qRef,
      (snap) => {
        let found = null;
        snap.forEach((d) => {
          const data = d.data() || {};
          const m = extractMazotMap(data);
          if (m) found = m;
        });
        setPerms(found);
        setReady(true);
      },
      (err) => {
        console.error("⚠️ users dinleme hatası:", err);
        setReady(true);
      }
    );

    return () => unsub();
  }, [user, userPermissions, userDoc]);

  return { ready, perms };
}


/* ---- yardımcılar aynen korunuyor ---- */

const Guard = ({ allow, children }) =>
  allow ? children : <div style={{ padding: 16 }}>Bu sayfayı görüntüleme yetkiniz yok.</div>;

export default function Main() {
  const { user, loading, userDoc, userPermissions } = useAuth();
  const { ready, perms } = useMazotPermissions(user, userPermissions, userDoc);

  if (loading || !ready) {
    return (
      <div>
        <Navbar />
        <div style={{ padding: 16 }}>Yükleniyor...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;

  const canCreator = !!perms?.olusturucu;
  const canInput = !!(perms?.giren || perms?.giren_onaylayan || perms?.olusturucu);
  const canApprove = !!(perms?.giren_onaylayan || perms?.olusturucu);
  const canView = !!(perms?.izleyen || canInput || canApprove);

  if (!canView) {
    return (
      <div>
        <Navbar />
        <div style={{ padding: 16 }}>Bu projeyi görüntüleme yetkiniz yok.</div>
      </div>
    );
  }

  const defaultPath = canInput ? "dolum" : "raporlar";

  return (
    <div>
      <Navbar />
      <div style={{ padding: 12 }}>
        <Routes>
          <Route index element={<Navigate to={defaultPath} replace />} />

          {/* Giriş yapanlar */}
          <Route path="dolum" element={<Guard allow={canInput}><DolumEkle /></Guard>} />
          <Route path="excel-yukle" element={<Guard allow={canInput}><YakitExcelYukle /></Guard>} />
          <Route path="dolum-duzelt" element={<Guard allow={canInput}><DolumDuzeltSil /></Guard>} />

          {/* Onaylayanlar */}
          <Route path="ikmal" element={<Guard allow={canApprove}><TankIkmal /></Guard>} />
          <Route path="tank-duzeltme" element={<Guard allow={canApprove}><TankDuzeltme /></Guard>} />

          {/* İzleyen / herkes */}
          <Route path="raporlar" element={<Guard allow={canView}><Raporlar /></Guard>} />
          <Route path="hareketler" element={<Guard allow={canView}><Hareketler /></Guard>} />
          <Route path="mazot-listesi" element={<Guard allow={canView}><MazotListesi /></Guard>} /> {/* ✅ */}

          {/* Sadece oluşturucu */}
          <Route path="mail-scheduler" element={<Guard allow={canCreator}><MailScheduler /></Guard>} />

          <Route path="*" element={<Navigate to={defaultPath} replace />} />
        </Routes>
      </div>
    </div>
  );
}
